// import ComponentA from './Components/ComponentA'
import Menu from './Components/Menu'
import ModalManager from './Components/ModalManager'
import ScrollingPage from './Components/ScrollingPage'
import ScrollingPage2 from './Components/ScrollingPage2'
import CountryPick from './Components/CountryPick'
import PopupMessage from './Components/PopupMessage'
import GraphicManager from './Components/GraphicManager'
import RevelPassword from './components/RevelPassword'
import InfoCard from './components/InfoCard'
import GraphicD3 from './components/GraphicD3'

document.addEventListener('DOMContentLoaded', () => {

    let root = {}
    root.menu = new Menu(root, [])
    root.menu.run()
    var data = []
    // (new ComponentA()).run()

    root.scrollingPage = new ScrollingPage(root, [])
    root.scrollingPage.run()

    root.scrollingPage2 = new ScrollingPage2(root, [])
    root.scrollingPage2.run()

    root.modalManager = new ModalManager(root, [])
    root.modalManager.run()

    root.popupMessage = new PopupMessage(root, [])
    root.popupMessage.run()

    root.countryPick = new CountryPick(root, [])

    root.graphicManager = new GraphicManager(root, [])
    root.graphicManager.run()

    root.revelPassword = new RevelPassword(root, [])
    root.revelPassword.run()

    root.infoCard = new InfoCard(root, [])
    root.graphicD3 = new GraphicD3(root, [])
}, false)